<template>
	<div
		class="footer"
		:class="{
			footersm: isSmallScreen
		}"
	>
		<div class="actions">
			<div>Rows per page:</div>
			<div style="width: 100px;">
				<v-select
					v-model="selectedRowNumbers"
					:items="rowNumbers"
					class="ml-4 mr-5"
				></v-select>
			</div>
		</div>
		<div class="actions">
			{{ offset + 1 }} -
			{{ offset + totalFetchedRows }}
			{{ " of " + totalEntries }}

			<v-btn
				fab
				flat
				@click="goBackward"
				:disabled="nextOffset === selectedRows"
			>
				<v-icon>chevron_left</v-icon>
			</v-btn>
			<v-btn fab flat @click="goForward" :disabled="nextOffset === -1">
				<v-icon>chevron_right</v-icon>
			</v-btn>
		</div>
	</div>
</template>

<script>
export default {
	name: "CustomFooter",
	props: [
		"goForward",
		"goBackward",
		"onRowNumberChange",
		"offset",
		"nextOffset",
		"totalFetchedRows",
		"totalEntries",
		"selectedRows"
	],
	data() {
		return {
			selectedRowNumbers: this.selectedRows,
			rowNumbers: [
				{ text: "5", value: 5 },
				{ text: "10", value: 10 },
				{ text: "25", value: 25 },
				{ text: "50", value: 50 },
				{ text: "100", value: 100 }
			]
		};
	},
	computed: {
		isSmallScreen() {
			let screen_size = this.$vuetify.breakpoint.name;
			return screen_size === "xs" || screen_size === "sm";
		}
	},
	watch: {
		selectedRowNumbers(newValue, oldValue) {
			if (newValue !== oldValue) {
				this.onRowNumberChange(newValue);
			}
		}
	}
};
</script>

<style scoped>
.footer {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
}

.footersm {
	flex-direction: column-reverse;
	align-items: flex-end;
}

.actions {
	display: flex;
	align-items: center;
}
</style>
